/** API route map: URLS.Controller.EmployeeLicenseCertificate */
export const EmployeeLicenseCertificate = {
      Name: 'EmployeeLicenseCertificate/',
      AddEmployeeLicense: 'add',
      UpdateEmployeeLicense: 'update',
      DeleteEmployeeLicense: 'delete',
      SpecificTypeValues: 'get-specific-type-value',
      GetAllLicenseCertificate: 'get-all-license-certificate',
};
